(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Findway-home-hero-scroll"] && !Shopify.designMode) return;
  try {
    
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const HEADER = 80;
  const MOBILE_BREAKPOINT = 980;

  const START_RADIUS = 999;
  const START_TARGET_PX = 140;
  const TEXT_LEN = 100;
  const BTN_LEN  = 60;

  const IMG2_LEN = 100;
  const IMG3_LEN = 100;

  let splitInstances = [];

  function killSectionTriggers() {
    ScrollTrigger.getAll().forEach(st => {
      const t = st.trigger;
      if (t && t.classList && t.classList.contains("fw-hhs-section")) st.kill();
    });
  }

  function buildHeroZoom() {
    killSectionTriggers();

    splitInstances.forEach(s => s?.revert?.());
    splitInstances = [];

    if (window.innerWidth <= MOBILE_BREAKPOINT) return;

    const section = document.querySelector(".fw-hhs-section");
    const pinEl   = document.querySelector(".fw-hhs-pin");
    const frame   = document.querySelector(".fw-hhs-frame");
    const texts   = document.querySelectorAll(".fw-hhs-txt");
    const btnWrap = document.querySelector(".fw-hhs-btns");

    const frame2   = document.querySelector(".fw-hhs-frame-2");
    const texts2   = document.querySelectorAll(".fw-hhs-txt-2");
    const btnWrap2 = document.querySelector(".fw-hhs-btns-2");

    const frame3   = document.querySelector(".fw-hhs-frame-3");
    const texts3   = document.querySelectorAll(".fw-hhs-txt-3");
    const btnWrap3 = document.querySelector(".fw-hhs-btns-3");

    if (!section || !pinEl || !frame || !texts.length || !btnWrap || !frame2 || !texts2.length || !btnWrap2 || !frame3 || !texts3.length || !btnWrap3) return;

    const h = pinEl.getBoundingClientRect().height;
    const startScale = Math.max(START_TARGET_PX / h, 0.03);

    const zoomST = ScrollTrigger.create({
      trigger: section,
      end: `top top+=${HEADER}px`
    });

    const viewH = () => pinEl.getBoundingClientRect().height;
    const imgOffset = () => viewH() * 0.5;
    const imgEnd = () => zoomST.end;
    const textStart = imgEnd;
    const textEnd = () => imgEnd() + (viewH() * (TEXT_LEN / 100));
    const btnEnd = () => textEnd() + (viewH() * (BTN_LEN  / 100));

    const img2End = () => btnEnd() + (viewH() * (IMG2_LEN / 100));
    const text2End = () => img2End() + imgOffset() + viewH() * (TEXT_LEN / 100);
    const btn2End = () => text2End() + (viewH() * (BTN_LEN  / 100));

    const img3End = () => btn2End() + (viewH() * (IMG3_LEN / 100));
    const text3End = () => img3End() + imgOffset() + viewH() * (TEXT_LEN / 100);
    const btn3End = () => text3End() + (viewH() * (BTN_LEN  / 100));
    
    // for pin
    ScrollTrigger.create({
      // id: "PIN",
      trigger: section,
      start: `top top+=${HEADER}px`,
      end: btn3End,
      pin: pinEl,
      pinSpacing: true,
      anticipatePin: 0,
      // markers: true,
      invalidateOnRefresh: true
    });

    gsap.fromTo(
      pinEl,
      { backgroundColor: "#000000" },
      {
        backgroundColor: "#f2f2f2",
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: imgEnd,
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );

    // frame 1
    gsap.set(frame, { transformOrigin: "50% 50%" });
    gsap.fromTo(
      frame,
      { scale: startScale, borderRadius: START_RADIUS },
      {
        scale: 0.95,
        borderRadius: 25,
        ease: "none",
        // for zoom
        scrollTrigger: {
          // id: "ZOOM",
          trigger: section,
          start: `top bottom`,
          end: imgEnd,
          scrub: true,
          // markers: true,
          invalidateOnRefresh: true
        }
      }
    );

    // frame 2
    gsap.set(frame2, { transformOrigin: "50% 50%" });
    gsap.fromTo(
      frame2,
      { xPercent: -100,
        // autoAlpha: 0, 
        scale: 0.95,
        borderRadius: 25
      },
      {
        xPercent: 0,
        // autoAlpha: 1,
        borderRadius: 25,
        ease: "none",
        scrollTrigger: {
          // id: "frame2",
          trigger: section,
          start: () => btnEnd() + imgOffset(),
          end: () => img2End() + imgOffset(),
          scrub: true,
          // markers: true,
          invalidateOnRefresh: true,
          onEnter: () => gsap.set(".fw-hhs-overlay-2", { pointerEvents: "auto" }),
          onLeaveBack: () => gsap.set(".fw-hhs-overlay-2", { pointerEvents: "none" })
        }
      }
    );

    // frame 3
    gsap.set(frame3, { transformOrigin: "50% 50%" });
    gsap.fromTo(
      frame3,
      { yPercent: -100,
        // autoAlpha: 0, 
        scale: 0.95,
        borderRadius: 25
      },
      {
        yPercent: 0,
        // autoAlpha: 1,
        ease: "none",
        scrollTrigger: {
          // id: "frame3",
          trigger: section,
          start: () => btn2End() + imgOffset(),
          end: () => img3End() + imgOffset(),
          scrub: true,
          // markers: true,
          invalidateOnRefresh: true,
          onEnter: () => gsap.set(".fw-hhs-overlay-3", { pointerEvents: "auto" }),
          onLeaveBack: () => gsap.set(".fw-hhs-overlay-3", { pointerEvents: "none" })
        }
      }
    );

    // texts 1
    let allWords = [];
    texts.forEach(el => {
      const sp = SplitText.create(el, { type: "chars" });
      splitInstances.push(sp);
      allWords = allWords.concat(sp.chars);
    });

    gsap.set(allWords, { x: 150, autoAlpha: 0 });

    gsap.to(allWords, {
      x: 0,
      // y: 0,
      autoAlpha: 1,
      ease: "none",
      stagger: 0.05,
      scrollTrigger: {
        // id: "TEXT",
        trigger: section,
        start: textStart,
        end: textEnd,
        scrub: true,
        // markers: true,
        invalidateOnRefresh: true
      }
    });

    // btns 1
    gsap.set(btnWrap, { scale: 0, autoAlpha: 0 });
    gsap.to(btnWrap, {
      scale: 1,
      autoAlpha: 1,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: textEnd,
        end: btnEnd,
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    // texts 2
    let allWords2 = [];
    texts2.forEach(el => {
      const sp = SplitText.create(el, { type: "lines" });
      splitInstances.push(sp);
      allWords2 = allWords2.concat(sp.lines);
    });

    gsap.set(allWords2, { y: 60, autoAlpha: 0 });

    gsap.to(allWords2, {
      y: 0,
      autoAlpha: 1,
      ease: "none",
      stagger: 0.05,
      scrollTrigger: {
        trigger: section,
        start: () => img2End() + imgOffset(),
        end: text2End,
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    // texts 3
    let allWords3 = [];
    texts3.forEach(el => {
      const sp = SplitText.create(el, { type: "words" });
      splitInstances.push(sp);
      allWords3 = allWords3.concat(sp.words);
    });

    gsap.set(allWords3, { y: 60, autoAlpha: 0 });

    gsap.to(allWords3, {
      y: 0,
      autoAlpha: 1,
      ease: "none",
      stagger: 0.05,
      scrollTrigger: {
        trigger: section,
        start: () => img3End() + imgOffset(),
        end: text3End,
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    // btns 2
    gsap.set(btnWrap2, { gap: 100, autoAlpha: 0 });
    gsap.to(btnWrap2, {
      gap: 48,
      autoAlpha: 1,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: text2End,
        end: btn2End,
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    // btns 3
    gsap.set(btnWrap3, { gap: 200, autoAlpha: 0 });
    gsap.to(btnWrap3, {
      gap: 48,
      autoAlpha: 1,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: text3End,
        end: btn3End,
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    ScrollTrigger.refresh();
  }
  
  const imgs = [
    document.getElementById("fw-hhs-img"),
    document.getElementById("fw-hhs-img-2"),
    document.getElementById("fw-hhs-img-3")
  ].filter(Boolean);

  Promise.all(
    imgs.map(async (img) => {
      if (!img.complete) {
        await new Promise(resolve => img.addEventListener("load", resolve, { once: true }));
      }

      if (img.decode) {
        try { await img.decode(); } catch (e) {}
      }
    })
  ).then(buildHeroZoom);

  window.addEventListener("resize", () => {
    clearTimeout(window.__fw_hhs_t);
    window.__fw_hhs_t = setTimeout(buildHeroZoom, 120);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Findway-tw-img-comparison"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', async function () {
  try {
    await window.theme.ensureImgComparisonSliderReady();
  } catch (err) {
    console.error('img comparison slides load failed:', err);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Findway-tw-table"] && !Shopify.designMode) return;
  try {
    
function cleanValue(v) {
  return v === undefined || v === null || v === 'undefined' ? '' : v;
}

function cleanNote(note) {
  note = cleanValue(note);
  if (!note) return '';

  try {
    if (note.charAt(0) === '[' && note.slice(-1) === ']') {
      var arr = JSON.parse(note);
      if (Array.isArray(arr)) return arr.join(', ');
    }
  } catch (e) {}
  return note;
}

function cleanYear(yr) {
  yr = cleanValue(yr);
  if (!yr) return '';

  try {
    if (yr.charAt(0) === '[' && yr.slice(-1) === ']') {
      var nums = JSON.parse(yr).map(function (n) { return parseInt(n, 10); })
                               .filter(function (n) { return !isNaN(n); });
      if (!nums.length) return '';
      var min = Math.min.apply(null, nums);
      var max = Math.max.apply(null, nums);
      return min === max ? String(min) : (min + '-' + max);
    }
  } catch (e) {}
  return yr;
}

function getLocalizedValue(row, field) {
  if (shopifyLocale === 'fr' && row.language?.fr?.[field]) {
    return row.language.fr[field];
  }
  return row[field];
}

document.addEventListener('DOMContentLoaded', function () {
  $(".fww-loading").removeClass("hidden");
  getPdpData().then(async function (res) {
    if (!res || !res.pdpTable) return;

    var rows = res.pdpTable.filter(function (r) {
      return r && typeof r === 'object';
    });

    await window.theme.ensurePdfMakeReady();
    await window.theme.ensureDataTablesReady(true);
    new DataTable('#fw-pdpTable', {
      pageLength: 25, 
      data: rows,
      layout: {
        bottom2Start: 'buttons'
      },
      buttons: [
        { extend: 'pdf',
          text: shopifyLocale === 'fr' ? 'Télécharger le PDF' : 'Download PDF',
          filename: (function () {
            const d = new Date();
            const yyyy = d.getFullYear();
            const mm   = String(d.getMonth() + 1).padStart(2, '0');
            const dd   = String(d.getDate()).padStart(2, '0');
            return 'PDP_List_' + `${yyyy}${mm}${dd}`;
          })(),
          title: shopifyLocale === 'fr'
            ? 'Liste du programme de développement de produits Findway'
            : 'Findway Product Development Program List',
          messageTop: shopifyLocale === 'fr'
            ? 'Les modèles peuvent être modifiés sans préavis. Veuillez nous contacter à l’avance lorsque vous aurez le véhicule qui nous intéresse. Les participants seront sélectionnés selon le principe du premier arrivé, premier servi.'
            : 'Models are subject to change without notice. Please contact us in advance once you have the vehicle we are interested in. Participants will be selected on a first-come, first-served basis.'
        }
      ],
      language: {
        lengthMenu: shopifyLocale === 'fr' ? '_MENU_ Modèles par page' : '_MENU_ Models Per Page',
        info: shopifyLocale === 'fr' ? 'Affichage de _START_ à _END_ sur _TOTAL_ modèles' : 'Showing _START_ to _END_ of _TOTAL_ Models',
      },
      fixedHeader: {
        header: true,
        headerOffset: 80
      },
      order: [[2, 'asc'], [3, 'asc'], [4, 'asc'], [5, 'asc']],
      columns: [
        {
          title: 'PDP #',
          data: null,
          render: function (_d, _t, row) {
            var v = '';
            if (row.Variants && row.Variants.length) {
              v = row.Variants[0].VariantSKU;
            }
            return cleanValue(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Produit' : 'Product',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'CollectionName');
            return cleanNote(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Marque' : 'Make',
          data: 'Make',
          render: function (d) { return cleanValue(d); }
        },
        {
          title: shopifyLocale === 'fr' ? 'Modèle' : 'Model',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'Model');
            return cleanNote(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Année' : 'Year',
          data: 'Year',
          render: function (d) { return cleanYear(d); }
        },
        {
          title: shopifyLocale === 'fr' ? 'Option' : 'Option',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'Option');
            return cleanNote(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Remarque' : 'Note',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'FitNote');
            return cleanNote(v);
          }
        }
      ]
    });
  }).finally(function () {
      $('.fww-loading').addClass('hidden');
  });
});

async function getPdpData() {
  try {
    const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pdpTable: true, lang: shopifyLocale }),
    });
 
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(`Error fetching data for Colls:`, error);
    return null;
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Findway-tw-wholesale"] && !Shopify.designMode) return;
  try {
    
const header  = document.querySelector('#fww-selection-header');
const wrapper = document.querySelector('.fww-ssr-table');

header.style.transform = `translateX(-${wrapper.scrollLeft}px)`;

wrapper.addEventListener('scroll', () => {
  header.style.transform = `translateX(-${wrapper.scrollLeft}px)`;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Findway-twfb-partner-application"] && !Shopify.designMode) return;
  try {
    
document.getElementById('pa-form').addEventListener('submit', async (e) => {
  e.preventDefault();
  const form = e.target;
  var paformsubmitBtn = document.getElementById("paformsubmit");

  paformsubmitBtn.textContent = shopifyLocale === 'fr' ? 'Chargement...' : 'Loading...';
  const payload = {
    companyName:   form['company-name'].value.trim(),
    companyWeb:    form['company-web'].value.trim(),
    email:         form['email'].value.trim(),
    confirmEmail:  form['confirm-email'].value.trim(),
    phoneNumber:   form['pa-phone-Number'].value.trim(),
    typeofCompany: form['pa-typeof-Company'].value,
    typeofBusiness:form['pa-typeof-Business'].value.trim(),
    yearFounded:   form['pa-year-Funded'].value.trim(),
    employees:     form['number-of-employees'].value,
    targetMarket:  form['target-Market'].value.trim(),
    hearUs:        form['pa-hear-Us'].value.trim(),
    desc:          form['business-desc'].value.trim(),
    firstName:     form['pa-first-Name'].value.trim(),
    lastName:      form['pa-last-Name'].value.trim(),
    address:       form['pa-company-address'].value.trim(),
    city:          form['pa-city'].value.trim(),
    province:      form['pa-province'].value.trim(),
    zip:           form['pa-zip'].value.trim(),
    country:       form['pa-country'].value,
    lang:           shopifyLocale || 'en'
  };

  const isFr = shopifyLocale === 'fr';

if (!paCheckEmails()) {
  Swal.fire({
    icon: "warning",
    title: isFr
      ? "Les adresses courriel ne correspondent pas."
      : "Email addresses do not match."
  });
  paformsubmitBtn.textContent = isFr ? "Soumettre" : "Submit";
  return;
} else {
  try {
    const res = await fetch(form.action, {
      method: form.method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error(await res.text());

    paformsubmitBtn.textContent = isFr ? "Soumis" : "Submitted";

    Swal.fire({
      icon: "success",
      title: isFr
        ? "Votre demande a été soumise avec succès !"
        : "Your application has been submitted successfully!",
      text: isFr
        ? "Un courriel de confirmation vous a été envoyé. Nous vous contacterons dans un délai de deux jours ouvrables."
        : "A confirmation email has been sent to you, and we will contact you within two business days."
    });

    form.reset();
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: "error",
      title: isFr
        ? "Échec de la soumission"
        : "Submission failed",
      text: isFr
        ? "Veuillez réessayer."
        : "Please try again."
    });
  }
}

  // if (!paCheckEmails()) {
  //   Swal.fire({
  //     icon: "warning",
  //     title: "Email addresses do not match."
  //   });
  //   paformsubmitBtn.textContent = "Submit";
  //   return;
  // } else {
  //   try {
  //     const res = await fetch(form.action, {
  //       method: form.method,
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(payload)
  //     });

  //     if (!res.ok) throw new Error(await res.text());
  //     paformsubmitBtn.textContent = "Submitted";
  //     Swal.fire({
  //       title: "Your application has been submitted successfully!",
  //       text: "A confirmation email has been sent to you, and we will contact you within two business days.",
  //       icon: "success"
  //     });
  //     form.reset();
  //   } catch (err) {
  //     console.error(err);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Submission failed",
  //       text: "Please try again."
  //     });
  //   }
  // }
});

function paCheckEmails() {
  var email = document.getElementById("pa-email").value.toLowerCase();
  var confirmEmail = document
    .getElementById("pa-confirm-email")
    .value.toLowerCase();

  if (email !== confirmEmail) {
    return false;
  }
  return true;
}

  } catch(e) { console.error(e); }
})();
})();
